const REPORTS_CAMPAIGNS_OPTIONS = {
  SCOPE: 'global_report',
  TITLE: 'Report',
};

export {
  REPORTS_CAMPAIGNS_OPTIONS,
}
